import { render } from "./TableS1.vue?vue&type=template&id=cfb8a0be&scoped=true"
import script from "./TableS1.vue?vue&type=script&lang=js"
export * from "./TableS1.vue?vue&type=script&lang=js"

import "./TableS1.vue?vue&type=style&index=0&id=cfb8a0be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cfb8a0be"

export default script